import { gql } from "@apollo/client";

export const BLOCK_RANGES_QUERY = gql`
  query institutionBlockRange($scenarioId: ID!) {
    data(scenarioId: $scenarioId) {
      institutionCalendarRange {
        startTime
        endTime
      }
    }
  }
`;
